<template>
  <div>
    <div class="flex justify-between items-center">
      <div>
        <h1>{{ business.name }}</h1>
      </div>
    </div>

    <div
      class="bg-white shadow-lg mb-10 mt-10 rounded-lg p-10"
      v-if="business.state != 'approved'"
    >
      <div class="flex justify-end">
        <el-button
          type="text"
          @click="declineBusiness"
          :loading="isDeclining"
          :disabled="isDeclining"
          >Decline</el-button
        >
        <el-button type="primary" @click="showApproveBusinessDialog = true"
          >Approve</el-button
        >
      </div>
    </div>

    <div class="card-container">
      <div class="bg-white rounded-lg p-10 shadow-lg mt-10">
        <label>Street address</label>
        <p class="mb-6">{{ business.streetAddress }}</p>

        <label>City</label>
        <p class="mb-6">{{ business.city }}</p>

        <label>Description</label>
        <p class="mb-6">{{ business.description }}</p>

        <label>Website</label>
        <p class="mb-6">
          <a :href="business.website">{{ business.website }}</a>
        </p>

        <label>Phone</label>
        <p class="mb-6">{{ business.phone }}</p>

        <label>RC number</label>
        <p class="mb-6">{{ business.rcNumber }}</p>

        <label>Year of incorporation</label>
        <p class="mb-6">{{ business.yearOfIncorporation }}</p>

        <label>Company size</label>
        <p class="mb-6">{{ business.companySize }}</p>

        <label>Customer type</label>
        <p class="mb-6">{{ business.customerType }}</p>

        <label>Industry type</label>
        <p class="mb-6">{{ business.industryType }}</p>

        <label>Entity type</label>
        <p class="mb-6">{{ business.entityType }}</p>

        <label>Desired line of credit</label>
        <p class="mb-6">{{ business.desiredLineOfCredit }}</p>

        <label>Annual revenue</label>
        <p class="mb-6">{{ business.annualRevenue }}</p>

        <label>Average monthly spend</label>
        <p class="mb-6">{{ business.averageMonthlySpend }}</p>

        <label>Country</label>
        <p class="mb-6">{{ business.country.name }}</p>

        <label>Documents</label>
        <ul class="flex flex-wrap">
          <li
            class="mb-2 mr-4"
            v-for="document in business.businessDocuments"
            :key="document.id"
          >
            <a :href="document.upload.url" target="_blank">{{
              document.upload.url
            }}</a>
          </li>
        </ul>
      </div>

      <div class="bg-white rounded-lg p-10 shadow-lg mt-10">
        <ul>
          <li
            class="mb-6"
            v-for="director in business.businessDirectors"
            :key="director.id"
          >
            <h2>
              {{ director.firstName }} {{ director.lastName }} ({{
                director.title
              }})
            </h2>
            <p class="mb-6">
              {{ director.email }} &bull; {{ director.phone }} &bull;
              {{ director.country.name }}
            </p>

            <label>BVN</label>
            <p class="mb-6">{{ director.bvn }}</p>

            <label>Date of birth</label>
            <p class="mb-6">{{ new Date(director.dob).toDateString() }}</p>

            <label>City, State</label>
            <p class="mb-6">{{ director.city }}, {{ director.state }}</p>

            <label>Identification</label>
            <p class="mb-6">
              {{ director.identificationType }} ({{
                director.identificationNumber
              }})
            </p>

            <label>Documents</label>
            <ul class="flex flex-wrap">
              <li
                class="mb-2 mr-4"
                v-for="document in director.businessDirectorDocuments"
                :key="document.id"
              >
                <a :href="document.upload.url" target="_blank">{{
                  document.upload.url
                }}</a>
              </li>
            </ul>
            <hr />
          </li>
        </ul>
      </div>
    </div>

    <el-dialog
      title="Approve business"
      :visible.sync="showApproveBusinessDialog"
      width="20%"
    >
      <label>Credit amount ({{ business.currency.name }})</label>
      <el-input v-model.number="creditAmount" />

      <span slot="footer">
        <el-button
          type="primary"
          @click="approveBusiness"
          :loading="isApproving"
          :disabled="isApproving"
          >Approve</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { FIND_BUSINESS_QUERY } from "@/api/queries";
import {
  APPROVE_BUSINESS_MUTATION,
  DECLINE_BUSINESS_MUTATION
} from "@/api/mutations";

export default {
  apollo: {
    business: {
      query: FIND_BUSINESS_QUERY,
      variables() {
        return { id: parseInt(this.$route.params.id) };
      },
      update: data => data.findBusiness
    }
  },
  data() {
    return {
      business: { country: {}, currency: {} },
      showApproveBusinessDialog: false,
      creditAmount: 1,
      isApproving: false,
      isDeclining: false
    };
  },
  methods: {
    async approveBusiness() {
      try {
        this.isApproving = true;
        const { data } = await this.$apollo.mutate({
          mutation: APPROVE_BUSINESS_MUTATION,
          variables: {
            amount: this.creditAmount * this.business.currency.factor,
            id: this.business.id
          }
        });

        if (data.approveBusiness.status == 200) {
          this.toastMessage("Business approved!");
          this.business.state = "approved";
          this.showApproveBusinessDialog = false;
        }

        this.isApproving = false;
      } catch (e) {
        this.loading = false;
        this.toastMessage("Something went wrong.", "error");
      }
    },
    async declineBusiness() {
      try {
        this.isDeclining = true;
        const { data } = await this.$apollo.mutate({
          mutation: DECLINE_BUSINESS_MUTATION,
          variables: {
            id: this.business.id
          }
        });

        if (data.declineBusiness.status == 200) {
          this.toastMessage("Business declined!");
          this.business.state = "failed_verification";
        }

        this.isDeclining = false;
      } catch (e) {
        this.isDeclining = false;
        this.toastMessage("Something went wrong.", "error");
      }
    }
  }
};
</script>
